import axios from 'axios';

const client = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'https://funnytask.net/api',
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('ft_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Token HẾT HẠN / không hợp lệ (401): xoá token + báo cho app đưa về màn ĐĂNG NHẬP, thay vì để
// màn hình kẹt "báo lỗi" (hay gặp trên app native khi token cũ hết hạn còn web thì vừa login lại).
client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && localStorage.getItem('ft_token')) {
      localStorage.removeItem('ft_token');
      try { window.dispatchEvent(new CustomEvent('ft:auth-expired')); } catch { /* ignore */ }
    }
    return Promise.reject(err);
  }
);

export default client;
